// components/CartModal.js
import React, { useEffect } from 'react';
import useCartStore from '../store/cartStore';
import Cart from './Cart';

function CartModal() {
  const isOpen = useCartStore((state) => state.isOpen);
  const closeCart = useCartStore((state) => state.closeCart);

  // Prevent scroll when cart is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  return (
    <>
      {/* Cart Modal - Lower z-index than Menu */}
      <div 
        className={`fixed top-0 left-0 w-full h-[500px] transform transition-all duration-300 z-[60] overflow-y-auto bg-white
          ${isOpen 
            ? 'translate-y-[80px] opacity-100 visible overflow-hidden' 
            : 'translate-y-[0px] opacity-0 invisible'}`
        }
      >
        <div className="flex justify-between items-center w-[90%] mx-auto max-w-7xl mt-9">
          <div className="text-[28px] font-bold mb-5 mt-7 text-gray-900 tracking-tight leading-tight">
           <h2>Shopping Cart</h2> 
          </div>
          <img
            src="/images/close_cross_big.svg"
            alt="Close"
            className="w-5 h-5 cursor-pointer"
            onClick={closeCart}
          />
        </div>
        <Cart />
      </div>
      
      {/* Backdrop overlay - Lower z-index than Menu overlay, but positioned below header */}
      <div
        className={`fixed top-[80px] left-0 w-full h-[calc(100%-80px)] bg-black/60 transition-opacity duration-500 z-[50] ${
          isOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
        }`}
        onClick={closeCart}
      ></div>
    </>
  );
}

export default CartModal;